import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import logo from "assets/images/common/others/logo.png";
import useStore from "hooks/useStore";

interface SidebarProps {
  children: ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ children }) => {
  const isSidebarExpanded = useSelector(
    (state: any) => state.sharedReducer?.isSidebarExpanded ?? true
  );

  const { setExpandSidebar } = useStore();
  const handleExpandSidebar = () => {
    setExpandSidebar(!isSidebarExpanded);
  };
  return (
    <aside
      className={`absolute top-0 left-0 md:relative h-screen ${
        isSidebarExpanded ? "w-full sm:w-[272px]" : "w-0"
      } bg-white`}
      style={
        {
          // backgroundImage: `url(/img/sidebarbg.png)`,
          // objectFit: "contain",
          // backgroundSize: "cover",
          // backgroundPosition: "center",
        }
      }
    >
      <nav className="h-full flex flex-col bg-transparent shadow-sm">
        <div className="p-4 py-5 flex justify-between items-center relative">
          <img
            src={logo}
            className={`overflow-hidden transition-all ${
              isSidebarExpanded ? "w-32" : "w-12"
            } mx-auto`}
            alt="Logo"
          />
          <button
            onClick={handleExpandSidebar}
            className={`${
              isSidebarExpanded ? "absolute" : " !hidden"
            }  z-10 top-8 right-5 block sm:hidden border border-gray-300 px-3 py-1 rounded-lg`}
          >
            x
          </button>
        </div>
        <ul className=" py-3  overflow-y-auto"> {children} </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
